const lightColor = {
  labelPrimaryInitial: '#ffffff',
  actionPrimaryInitial: '#449cff',
  iconPositiveInitial: '#127f42',
  iconNegativeInitial: '#f7034d',
  iconNeutralSoft: '#D1D5D6',
  iconNeutralMedium: '#8E9699',
  surfaceCanvasPrimaryInitial: '#FFFFFF', //neutral050
  surfaceCanvasSecondaryInitial: '#F9FAFA', //neutral100
  surfaceCanvasTertiaryInitial: '#eef1f1', //neutral200
  textNeutralStrong: '#202124',
  priceStopLossBackgroundColor: '#dd0244', // negativeContrastInitial
  priceStopLossLineColor: '#f7034d', // strokeNegativeInitial
  priceTakeProfitBackgroundColor: '#127F42', //positiveContrastInitial
  priceTakeProfitLineColor: '#127f42', //strokePositiveInitial
}

const darkColor = {
  labelPrimaryInitial: '#ffffff',
  actionPrimaryInitial: '#449cff',
  iconPositiveInitial: '#25D272',
  iconNegativeInitial: '#fd5369',
  iconNeutralSoft: '#BCC1C2',
  iconNeutralMedium: '#D1D5D6',
  surfaceCanvasPrimaryInitial: '#202124', // neutral900
  surfaceCanvasSecondaryInitial: '#23282a', //neutral800
  surfaceCanvasTertiaryInitial: '#3a4245', //neutral750
  textNeutralStrong: '#FFFFFF',
  priceStopLossBackgroundColor: '#63011f', // surfaceNegativeInitial
  priceStopLossLineColor: '#fd5369', // strokeNegativeInitial
  priceTakeProfitBackgroundColor: '#0f542e', //surfacePositiveInitial
  priceTakeProfitLineColor: '#45de89', //strokePositiveInitial
}

export const TBCC_TRADING_VIEW_COLORS = {
  light: {
    labelPrimaryInitial: lightColor.labelPrimaryInitial,
    backgroundColor: lightColor.surfaceCanvasPrimaryInitial,
    barDownColor: lightColor.iconNegativeInitial,
    barUpColor: lightColor.iconPositiveInitial,
    color: lightColor.actionPrimaryInitial,
    textColor: lightColor.textNeutralStrong,
    volumeBarColor: lightColor.iconNeutralSoft,
    crossHairColor: lightColor.iconNeutralMedium,
    crossHairBgColor: lightColor.iconNeutralSoft,
    priceStopLossBackgroundColor: lightColor.priceStopLossBackgroundColor,
    priceStopLossLineColor: lightColor.priceStopLossLineColor,
    priceTakeProfitBackgroundColor: lightColor.priceTakeProfitBackgroundColor,
    priceTakeProfitLineColor: lightColor.priceTakeProfitLineColor,
  },
  dark: {
    labelPrimaryInitial: darkColor.labelPrimaryInitial,
    backgroundColor: darkColor.surfaceCanvasPrimaryInitial,
    barDownColor: darkColor.iconNegativeInitial,
    barUpColor: darkColor.iconPositiveInitial,
    color: darkColor.actionPrimaryInitial,
    textColor: darkColor.textNeutralStrong,
    volumeBarColor: darkColor.iconNeutralSoft,
    crossHairColor: darkColor.iconNeutralMedium,
    crossHairBgColor: darkColor.iconNeutralSoft,
    priceStopLossBackgroundColor: darkColor.priceStopLossBackgroundColor,
    priceStopLossLineColor: darkColor.priceStopLossLineColor,
    priceTakeProfitBackgroundColor: darkColor.priceTakeProfitBackgroundColor,
    priceTakeProfitLineColor: darkColor.priceTakeProfitLineColor,
  },
}

export const TBCC_TRADING_VIEW_SIMPLE_CHART_COLORS = {
  light: {
    actionDefault: lightColor.actionPrimaryInitial, //
    backgroundPrimary: lightColor.surfaceCanvasPrimaryInitial,
    backgroundSecondary: lightColor.surfaceCanvasSecondaryInitial,
    strokeNeutralSoftInitial: lightColor.surfaceCanvasTertiaryInitial,
    positive: lightColor.iconPositiveInitial,
    negative: lightColor.iconNegativeInitial,
    labelPrimary: lightColor.textNeutralStrong,
  },
  dark: {
    actionDefault: darkColor.actionPrimaryInitial, //
    backgroundPrimary: darkColor.surfaceCanvasPrimaryInitial,
    backgroundSecondary: darkColor.surfaceCanvasSecondaryInitial,
    strokeNeutralSoftInitial: darkColor.surfaceCanvasTertiaryInitial,
    positive: darkColor.iconPositiveInitial,
    negative: darkColor.iconNegativeInitial,
    labelPrimary: lightColor.textNeutralStrong,
    labelBackground: lightColor.surfaceCanvasPrimaryInitial,
  },
}
